import { useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { getDocumentsQueue } from '../requests';

/**
 * Hook to update the key of a document query collection query
 */
export const useUpdateDocumentQueueCollectionKey = () => {
  const queryClient = useQueryClient();

  return async (documentId: number) => {
    const queries = queryClient.getQueriesData({});
    const documentQuery: any = await queryClient.ensureQueryData(
      [API_QUERY_KEYS.documentsQueue, { documentId }],
      {
        queryFn: () => getDocumentsQueue({ documentId }),
      },
    );

    // refetch all documents queries
    queries.forEach((query: any) => {
      if (
        query[0][0] === API_QUERY_KEYS.documentQueueCollection &&
        Array.isArray(query[0][1]) &&
        query[0][1].map(id => `${id}`).includes(`${documentId}`)
      ) {
        const data: any[] = query[1];

        if (data && Array.isArray(data)) {
          const newData = data.map((item: any) =>
            `${item.documentId}` === `${documentId}`
              ? {
                  documentId,
                  data: documentQuery,
                }
              : item,
          );

          queryClient.setQueryData(query[0], newData);
        }
      }
    });
  };
};
